import React, { useState, useEffect, useContext } from "react";
import { validate } from './Validate';
import useForm from '../banner/customHooks';
import { X_TENANT_ID, ACTIONGRID, UPLOADIMAGE } from '../../common/ActionUrl'
import axios from 'axios';
import { AuthContext } from "../../common/Auth"
import ActionGridForm from './ActionGridForm';
import { _useToasts } from "../../common/_useToasts";
import { USERTYPES } from "../../constant/userType";

import { useConfirm } from "material-ui-confirm";

const ActionGrid = ({ actionGridId, handleClose, fromEditAction }) => {

    const { user, userType, getActionGridDetails } = useContext(AuthContext)

    const { inputs, handleInputChange, resetCode, handleCheckboxInputChange, handleFileInputChange, setImage, resetColor, handleSubmit, handleColorPicker, errors } = useForm({ image: "", titleCss: "", isOverWriteTitle: false, flag: true, title: "", description: "", descriptionWidth: "", imageWidth: "", imageHeight: "", titleImageWidth: "", titleImageHeight: "", bgColor: "", updatedBy: "", titleImage: "", createdBy: "" }, validate, updateActionGridCallback);

    const { _addToast } = _useToasts();
    const [actionGridData, setActionGridData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [tempImage, setTempImage] = useState("");
    const [tempTitle, setTempTitle] = useState("");
    const [tempDesc, setTempDesc] = useState("");
    const [tempTitleImage, setTempTitleImage] = useState("");
    const userId = user?.userId

    async function updateActionGridCallback() {

        setIsLoading(true)
        if (actionGridId) {
            const requestOptions = {
                headers: { 'Content-Type': 'multipart/form-data', 'X-TENANT-ID': X_TENANT_ID },
            };
            const formData = new FormData()

            formData.append("image", inputs.image)
            formData.append("imageWidth", inputs.imageWidth)
            formData.append("imageHeight", inputs.imageHeight)
            formData.append("titleImage", inputs.titleImage)
            formData.append("titleImageWidth", inputs.titleImageWidth)
            formData.append("titleImageHeight", inputs.titleImageHeight)


            if (inputs.title != undefined && inputs.title != "undefined" && inputs.title.includes("<p>")) {
                inputs.title = inputs.title.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
                inputs.title = inputs.title.substr(0, inputs.title.length - 5);
            }
            formData.append("title", inputs.title)

            if (inputs.description != undefined && inputs.description != "undefined" && inputs.description.includes("<p>")) {
                inputs.description = inputs.description.replace(/<p>/g, "").replace(/<\/p>/g, "<br/>");
                inputs.description = inputs.description.substr(0, inputs.description.length - 5);
            }
            formData.append("description", inputs.description)
            formData.append("descriptionWidth", inputs.descriptionWidth)
            formData.append("bgColor", inputs.bgColor)
            formData.append("updatedBy", userId)

            axios.patch(ACTIONGRID + actionGridId, formData, requestOptions)
                .then(res => {
                    setIsLoading(false)
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast("Action grid updated successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                        getActionGridDetails()
                        handleClose()
                    }
                }).catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast('Issues while update action grid', {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                })
        }
    }

    const getActionGrid = () => {

        setIsLoading(true)
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID },
        };
        axios.get(ACTIONGRID + actionGridId, requestOptions)
            .then(res => {
                setIsLoading(false)
                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    setActionGridData(res.data)
                }
            }).catch(err => {
                console.log('err', err);
            });
    }

    useEffect(() => {

        if (actionGridId) {
            getActionGrid()
        }
    }, [actionGridId])

    //its a temp value for update inputs value when edit banner
    const [value, setValue] = useState(0);
    useEffect(() => {

        if (Object.keys(actionGridData).length > 0) {

            inputs.image = actionGridData.image
            inputs.imageWidth = actionGridData.imageWidth
            inputs.imageHeight = actionGridData.imageHeight
            inputs.titleImage = actionGridData.titleImage
            inputs.titleImageWidth = actionGridData.titleImageWidth
            inputs.titleImageHeight = actionGridData.titleImageHeight
            inputs.title = actionGridData.title
            inputs.description = actionGridData.description
            inputs.descriptionWidth = actionGridData.descriptionWidth
            inputs.bgColor = actionGridData.bgColor
            setTempDesc(actionGridData.description)
            setTempTitle(actionGridData.title)
            setTempImage(actionGridData.image)
            setTempTitleImage(actionGridData.titleImage)
            setValue(value => value + 1)
        }
    }, [actionGridData])

    useEffect(() => {

        if (inputs.image != '' && inputs.image !== "undefined" && inputs.image !== undefined && inputs.image.name) {
            setTempImage(URL.createObjectURL(inputs.image))
        }
    }, [inputs.image])

    useEffect(() => {

        if (inputs.titleImage != '' && inputs.titleImage !== "undefined" && inputs.titleImage !== undefined && inputs.titleImage.name) {
            setTempTitleImage(URL.createObjectURL(inputs.titleImage))
        }
    }, [inputs.titleImage])


    const deleteImage = (type) => {

        if (type === 'titleImage') {
            setTempTitleImage("")
        } else if (type === 'image') {
            setTempImage("")
        }
    }

    const confirm = useConfirm();
    const resetSettings = (value, name) => {
        confirm({
            description: ``, title: 'Reset to last saved text?', confirmationText: "Reset", dialogProps: { maxWidth: 'xs' }
        }).then(() => {
            resetCode(value, name)
        }).catch((err) => "");
    }

    return (
        <>

            <div className="contact-area pt-10 pb-10">
                {userType !== USERTYPES.USER ?
                    <>
                        <ActionGridForm
                            setImage={setImage}
                            handleFileInputChange={handleFileInputChange}
                            isLoading={isLoading}
                            inputs={inputs}
                            handleSubmit={handleSubmit}
                            handleInputChange={handleInputChange} errors={errors}
                            handleColorPicker={handleColorPicker}
                            actionGridId={actionGridId}
                            handleClose={handleClose}
                            fromEditAction={fromEditAction}
                            deleteImage={deleteImage}
                            tempImage={tempImage}
                            tempTitleImage={tempTitleImage}
                            handleCheckboxInputChange={handleCheckboxInputChange}
                            resetSettings={resetSettings}
                            tempTitle={tempTitle}
                            tempDesc={tempDesc}
                            resetColor={resetColor}

                        />
                    </> : <h2>You haven't authority for update action grid settings</h2>}
            </div>

        </>
    );
};

export default ActionGrid;
